import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import adminClasses from "../AdminDashboardView/AdminDashboardView.module.css";
import SalesDashboardActivityPanels from "./SalesDashboardActivityPanels";
import SalesDashboardCharts from "./SalesDashboardCharts";
import SalesDashboardKpiGrid from "./SalesDashboardKpiGrid";
import BookingStats from "../../../sales/components/BookingStats";
import { LEADS_APP_PATH } from "./salesDashboard.constants";

const SalesDashboardContent = ({ dashboard }) => {
  const navigate = useNavigate();
  const onNavigate = useCallback(() => navigate(LEADS_APP_PATH), [navigate]);

  return (
    <div className={adminClasses.tabStack}>
      <SalesDashboardKpiGrid items={dashboard.row1Kpis} isLoading={dashboard.isStatsLoading} />
      <BookingStats />
      <SalesDashboardCharts dashboard={dashboard} />
      <SalesDashboardActivityPanels dashboard={dashboard} onNavigate={onNavigate} />
    </div>
  );
};

export default SalesDashboardContent;
